<template>
  <el-dialog
    custom-class="custom-dialog"
    v-on="$listeners"
    v-bind="$attrs"
    width="450px"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <template #title>
      <span v-if="form">{{ form.id === 0 ? "添加用户" : "编辑用户" }}</span>
    </template>
    <div class="dialog-main-box" v-if="form">
      <el-form :model="form" ref="form" label-width="80px">
        <el-form-item label="账号:" required>
          <el-input v-model="form.account" :readonly="form.id > 0">
            <el-select
              v-model="form.isEnable"
              slot="append"
              placeholder="状态"
              style="width:75px;"
            >
              <el-option :value="true" label="启用"></el-option>
              <el-option :value="false" label="停用"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="密码:" :required="form.id === 0">
          <el-input
            type="password"
            v-model.trim="form.password"
            :placeholder="
              form.id > 0 ? '不修改请留空' : '大小写英文/数字/特殊字符,8-16位'
            "
            autocomplete="off"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="姓名:" required>
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号:">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="邮箱:">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <el-button type="primary" @click="submitForm">提交</el-button>
      <el-button @click="handleClose">取消</el-button>
    </template>
  </el-dialog>
</template>

<script>
import _ from "lodash";
import AUTH from "@/api/auth";
export default {
  data() {
    return {
      form: null
    };
  },
  props: {
    userData: {
      type: Object
    }
  },
  created() {},
  watch: {
    userData: {
      immediate: true,
      handler: "resetData"
    }
  },
  methods: {
    resetData() {
      this.form = this.userData
        ? _.cloneWith(this.userData)
        : this.createUser();
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.resetData();
    },
    createUser() {
      return {
        id: 0,
        account: "",
        name: "",
        phone: "",
        email: "",
        password: "",
        isEnable: true
      };
    },
    async submitForm() {
      if (this.form.account.trim() === "") {
        this.$message.error("请输入账号");
      } else if (this.form.password.trim() === "" && this.form.id === 0) {
        this.$message.error("请输入密码");
      } else if (this.form.name.trim() === "") {
        this.$message.error("请输入姓名");
      } else {
        if (this.form.id === 0) {
          // 添加用户
          let response = await AUTH.ADD(this.form);
          if (response.data.state) {
            try {
              // 刷新授权列表
              this.$emit("refresh");
              await this.$confirm("添加用户成功,是否继续添加?", "提示", {
                confirmButtonText: "添加",
                cancelButtonText: "取消",
                type: "success",
                lockScroll: false
              });
              this.form = this.createUser();
            } catch {
              this.handleClose();
            }
          } else {
            this.$message.error(response.data.message);
          }
        } else {
          // 编辑用户
          let response = await AUTH.EDIT(this.form);
          if (response.data.state) {
            try {
              // 刷新授权列表
              this.$emit("refresh");
              await this.$confirm("编辑用户成功,是否调整?", "提示", {
                confirmButtonText: "调整",
                cancelButtonText: "取消",
                type: "success",
                lockScroll: false
              });
            } catch {
              this.handleClose();
            }
          } else {
            this.$message.error(response.data.message);
          }
        }
      }
    }
  }
};
</script>
